import React from 'react';
import {
  FacebookShareButton, FacebookIcon,
  TwitterShareButton, TwitterIcon,
  TelegramShareButton, TelegramIcon,
  WhatsappShareButton, WhatsappIcon,
  LinkedinShareButton, LinkedinIcon,
} from "react-share";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import i18n from '../../../i18n/i18n';

import useToasts from '../../../hooks/useToasts';

const ShareParkingModal = ({ onCloseModal, parkingArea }) => {
  const { toastSuccess } = useToasts();

  return (
    <div aria-hidden="true" className="fixed top-0 left-0 right-0 bottom-0 z-50 w-full p-4 overflow-x-hidden overflow-y-auto max-h-screen">
      <div className="flex items-center justify-center max-w-[80%] min-h-screen mx-auto md:max-w-[500px] lg:max-w-[700px]">
        <div className="fixed inset-0 transition-opacity">
          <div className="absolute inset-0 bg-gray-900 opacity-75" />
        </div>
        <div className="relative bg-white rounded-lg shadow w-full">
          <div className="flex flex-col px-[40px] py-[30px]">
            <button type="button" onClick={onCloseModal} className="absolute top-3 right-2.5 text-[#929292] bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 z-20 ml-auto inline-flex justify-center items-center">
              <FontAwesomeIcon icon={faClose} />
            </button>

            <div className="mb-[10px] text-primary900 text-[20px] font-bold">{i18n.t("findParking.shareParking.shareCode")}</div>
            <div className="mb-[20px] text-black text-[16px] font-bold">{parkingArea.name}</div>

            <div className="flex flex-col items-center px-[20px] py-[15px] border-[1px] border-[#CCCCCC] border-dashed md:flex-row">
              <div className="w-full text-black text-[12px] text-center whitespace-nowrap overflow-hidden text-ellipsis md:mr-[10px] md:text-start lg:text-[14px]">{window.location.origin}/parking-area/{parkingArea.additionalInformation.slugName}</div>
              <button className="bg-[#E0E0E0] mt-[10px] px-[10px] py-[5px] text-black text-[15px] font-medium rounded-[5px] md:mt-[0px] md:ml-auto"
                onClick={() => {
                  navigator.clipboard.writeText(`${window.location.origin}/parking-area/${parkingArea.additionalInformation.slugName}`).then(() => {
                    toastSuccess(i18n.t("findParking.shareParking.copied"));
                  });
                }}>{i18n.t("findParking.shareParking.copy")}</button>
            </div>

            <div className="flex flex-row flex-wrap mt-[20px]">
              <FacebookShareButton className="mr-[8px] mb-[10px] lg:mr-[10px]" url={`${window.location.origin}/parking-area/${parkingArea.additionalInformation.slugName}`}>
                <FacebookIcon size={32} round={true} />
              </FacebookShareButton>
              <TwitterShareButton className="mr-[8px] mb-[10px] lg:mr-[10px]" url={`${window.location.origin}/parking-area/${parkingArea.additionalInformation.slugName}`}>
                <TwitterIcon size={32} round={true} />
              </TwitterShareButton>
              <TelegramShareButton className="mr-[8px] mb-[10px] lg:mr-[10px]" url={`${window.location.origin}/parking-area/${parkingArea.additionalInformation.slugName}`}>
                <TelegramIcon size={32} round={true} />
              </TelegramShareButton>
              <WhatsappShareButton className="mr-[8px] mb-[10px] lg:mr-[10px]" url={`${window.location.origin}/parking-area/${parkingArea.additionalInformation.slugName}`}>
                <WhatsappIcon size={32} round={true} />
              </WhatsappShareButton>
              <LinkedinShareButton className="mr-[8px] mb-[10px] lg:mr-[10px]" url={`${window.location.origin}/parking-area/${parkingArea.additionalInformation.slugName}`}>
                <LinkedinIcon size={32} round={true} />
              </LinkedinShareButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ShareParkingModal;